var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M31.5333 15C30.7233 9.34833 25.8767 5 20 5C14.1233 5 9.27667 9.34833 8.46667 15H31.5333Z",
    fill: "#015BBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 13.3333H11.6666C8.90996 13.3333 6.66663 15.5766 6.66663 18.3333V19.9999H9.99996V18.3333C9.99996 17.4149 10.7483 16.6666 11.6666 16.6666H28.3333C29.2516 16.6666 30 17.4149 30 18.3333V19.9999H33.3333V18.3333C33.3333 15.5766 31.09 13.3333 28.3333 13.3333Z",
    fill: "#015BBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 19.6116V16.6666C33.3333 9.31492 27.3517 3.33325 20 3.33325C12.6483 3.33325 6.66667 9.31492 6.66667 16.6666V19.6116C5.62 20.5483 5 21.8999 5 23.3333C5 25.4599 6.37167 27.3283 8.32 28.0266C10.66 33.3799 15.0717 36.6666 20 36.6666C24.9283 36.6666 29.34 33.3799 31.68 28.0266C33.6283 27.3283 35 25.4599 35 23.3333C35 21.8999 34.38 20.5483 33.3333 19.6116ZM30.2283 24.9683L29.2533 25.1033L28.9017 26.0216C27.17 30.5316 23.76 33.3333 20 33.3333C16.24 33.3333 12.83 30.5316 11.1 26.0233L10.7483 25.1049L9.77333 24.9699C8.95167 24.8566 8.33333 24.1533 8.33333 23.3333C8.33333 22.7333 8.64333 22.1966 9.16333 21.8983L10 21.4183V16.6666C10 11.1516 14.485 6.66659 20 6.66659C25.515 6.66659 30 11.1516 30 16.6666V21.4183L30.8367 21.8983C31.3567 22.1966 31.6667 22.7333 31.6667 23.3333C31.6667 24.1533 31.0483 24.8566 30.2283 24.9683Z",
    fill: "#015BBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.4333 26.6667C29.8833 28.0667 29.1833 29.3501 28.3333 30.4501C26.2333 33.2667 23.2833 35.0001 20 35.0001C16.7167 35.0001 13.7667 33.2667 11.6667 30.4501C10.8167 29.3501 10.1167 28.0667 9.56665 26.6667H30.4333Z",
    fill: "#015BBB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4833 28.2516C23.1899 26.1982 16.8099 26.1982 10.5166 28.2516L9.48328 25.0832C16.4616 22.8066 23.5399 22.8066 30.5166 25.0832L29.4833 28.2516Z",
    fill: "#015BBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMask);
export default __webpack_public_path__ + "static/media/mask.67841c192195981880ab4c3bbc6a215a.svg";
export { ForwardRef as ReactComponent };